'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGE_TYPE_ID = exports.MESSAGE_TYPE_ID = '@type';
var ACTIVELY_PUBLISHING = exports.ACTIVELY_PUBLISHING = 'ACTIVELY_PUBLISHING';
var FAILED_TO_PUBLISH = exports.FAILED_TO_PUBLISH = 'FAILED_TO_PUBLISH';